<template>
    <div class="cabinet-content-wrap">
        <SearchAndBasket />

        <section class="cabinet__breadcrumbs">
            <router-link to="/" class="cabinet__breadcrumbs-link"
                >Главная</router-link
            >
            <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
            <a href="javascript:void(0)" class="cabinet__breadcrumbs-link"
                >Бренды</a
            >
        </section>

        <div class="cabinet__product-page">
            <header class="cabinet-header flex flex-align-center">
                <h1 class="h1">Бренды</h1>
            </header>

            <section
                class="cabinet-panel cabinet-panel--suppliers cabinet-panel--small-margin flex"
            >
                <form
                    class="cabinet-search cabinet-search--small v2-retailer-brands__search"
                    @submit.prevent="search"
                >
                    <label
                        class="cabinet-search__label"
                        for="cabinet-search__input"
                    ></label>
                    <input
                        id="cabinet-search__input"
                        v-model="searchText"
                        type="text"
                        class="cabinet-search__input"
                        placeholder="Поиск"
                    />
                </form>
                <button
                    type="button"
                    class="cabinet-btn-icon cabinet-btn-icon--default cabinet-btn-icon--filter d-lg-none"
                    @click="mFilterOpen = true"
                ></button>
            </section>

            <brands-filters
                :filter="filter"
                :m-filter-open="mFilterOpen"
                @onChangeFilter="applyFilter"
                @onCloseMFilter="mFilterOpen = false"
            />

            <div v-if="errors.brands">
                <div class="error text-center">
                    <div class="error-image">
                        <img src="/img/icons/error.svg" alt="" />
                    </div>
                    <div class="error-title">
                        Упс! Что-то пошло не так.
                    </div>
                    <div class="error-button">
                        <button
                            type="button"
                            class="cabinet-btn"
                            @click="tryGetBrands"
                        >
                            Попробовать еще раз
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="paginatedBrands.length && !loading && !errors.brands">
                <section class="cabinet-table-options-wrap mb-0">
                    <div
                        class="cabinet-table-options flex flex-align-center justify-content-between"
                    >
                        <div>
                            <span class="d-none d-md-inline-block">
                                {{
                                    pagination.page * pagination.pageSize +
                                        1 -
                                        pagination.pageSize
                                }}
                                -
                            </span>
                            {{
                                Math.min(
                                    pagination.page * pagination.pageSize,
                                    pagination.totalItems
                                )
                            }}

                            из {{ pagination.totalItems }}
                        </div>

                        <div
                            class="cabinet-table-options-pagination flex flex-justify-sb flex-align-center d-none d-md-flex"
                        >
                            <div class="d-none d-md-block">
                                <table-pagination
                                    :current-page="pagination.page"
                                    :total-pages="pagination.totalPages"
                                    :total-products="pagination.totalItems"
                                    :disable-scroll-top="isMobile"
                                    @setPage="onSetPage($event)"
                                />
                            </div>
                        </div>
                    </div>
                </section>

                <section class="v2-retailer-brands">
                    <brand-item
                        v-for="brand of paginatedBrands"
                        :key="brand.BrandID"
                        :brand="brand"
                        @onClickToRequestAccess="openRequestAccessModal"
                        @change-subscription="changeSubscription"
                        @change-favourite="changeFavourite"
                    />
                </section>

                <section
                    class="cabinet-table-options flex flex-justify-sb flex-align-center d-none d-md-flex"
                >
                    <select-picker
                        :current-value="pagination.pageSize"
                        :options="pageSizes"
                        key-value="id"
                        key-title="title"
                        select-width="80"
                        :classes="['select', 'select--small']"
                        @onChange="onPageSizeChange($event)"
                    />

                    <table-pagination
                        :current-page="pagination.page"
                        :total-pages="pagination.totalPages"
                        :total-products="pagination.totalItems"
                        :disable-scroll-top="isMobile"
                        @setPage="onSetPage($event)"
                    />
                </section>

                <section
                    v-if="pagination.page < pagination.totalPages"
                    class="flex flex-column flex-align-center pb-4 d-md-none"
                >
                    <button
                        type="button"
                        class="cabinet-btn cabinet-btn--default"
                        :disabled="pagination.page >= pagination.totalPages"
                        @click="updateBrandList(pagination.page + 1, true)"
                    >
                        Загрузить еще
                    </button>
                </section>
            </div>
            <div
                v-if="!paginatedBrands.length && !loading && !errors.brands"
                class="w-md-50 text-center ml-auto mr-auto pt-5 pb-5"
            >
                <img
                    v-if="filter !== 'all'"
                    src="/img/icons/empty-search.svg"
                    class="dashboard-empty__img ofi"
                />
                <img
                    v-else
                    src="/img/icons/empty-goods.svg"
                    class="dashboard-empty__img ofi"
                />
                <div class="dashboard-empty__title pt-5">
                    {{
                        filter !== 'all'
                            ? 'По Вашему запросу брендов не найдено'
                            : 'Нет ни одного бренда'
                    }}
                </div>
            </div>

            <request-access-modal
                :is-open="isOpenRequestAccessBrandModal"
                :brand="requestAccessBrand"
                @onConfirm="sendBrandAccessRequest"
                @onClose="closeRequestAccessModal"
            />
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import SelectPicker from '@/components/Elements/SelectPicker'
import TablePagination from '@/components/Cabinet/Pagination/TablePagination'

import BrandItem from '@/components/Cabinet/Retailer/Brands/BrandItem'
import RequestAccessModal from '@/components/Cabinet/Retailer/Brands/RequestAccessModal'
import BrandsFilters from '@/components/Cabinet/Retailer/Brands/BrandsFilters'
import SearchAndBasket from '@/components/Public/SearchAndBasket'

import checkDemoUser from '@/mixins/checkDemoUser.js'
import onResize from '@/mixins/on-resize'

let pageSizes = [10, 20, 50, 100].map(item => {
    return {
        id: item,
        title: item
    }
})

export default {
    name: 'RetailerBrands',
    components: {
        SelectPicker,
        TablePagination,
        BrandItem,
        RequestAccessModal,
        BrandsFilters,
        SearchAndBasket
    },
    mixins: [checkDemoUser, onResize],
    data() {
        return {
            pageSizes,
            loading: true,
            requestAccessBrand: null,
            isOpenRequestAccessBrandModal: false,
            searchText: '',
            filter: 'all',
            initialScrollTop: '',
            error: false,
            mFilterOpen: false
        }
    },
    computed: {
        ...mapState('retailerBrand', ['brands', 'mobileBrands', 'errors']),
        ...mapGetters('retailerBrand', ['pagination', 'selectedFilter']),
        paginatedBrands() {
            if (document.documentElement.clientWidth > 767) {
                return this.brands
            }
            return this.mobileBrands
        }
    },
    watch: {
        brands: function(val) {
            if (this.initialScrollTop && val.length) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        window
                            .$('html, body')
                            .animate(
                                { scrollTop: this.initialScrollTop },
                                'slow'
                            )
                        this.initialScrollTop = ''
                    }, 800)
                })
            }
        }
    },
    created() {
        if (this.selectedFilter) {
            this.filter = this.selectedFilter.letter
        }

        if (this.pagination.page) {
            this.updateBrandList(this.pagination.page)
        } else {
            this.updateBrandList(1)
        }
    },

    beforeRouteEnter(to, from, next) {
        if (from.name === 'RetailerBrandsID') {
            next(vm => {
                vm.initialScrollTop = window.localStorage.getItem(
                    'brandsListScrollTop'
                )
            })
        } else {
            next()
        }
    },
    beforeRouteLeave(to, from, next) {
        window.localStorage.setItem(
            'brandsListScrollTop',
            window.$(document).scrollTop()
        )
        next()
    },

    methods: {
        ...mapActions('retailerBrand', [
            'getBrands',
            'setPagination',
            'setSelectedFilter',
            'subscribeOnBrand',
            'unsubscribeOnBrand',
            'addBrandInFavourite',
            'removeBrandFromFavourite',
            'requestAccessToBrand'
        ]),
        updateBrandList(page = 1, isMobilePagination = false) {
            this.$Progress.start()

            let data = { page, isMobilePagination }

            if (this.search) {
                data.search = this.searchText
            }

            switch (this.filter) {
                case 'all': {
                    break
                }

                case 'num': {
                    data.first_num = true
                    break
                }

                case 'favourite': {
                    data.favorite = true
                    break
                }

                default: {
                    data.first_char = this.filter
                }
            }
            this.loading = true
            this.getBrands(data).then(() => {
                this.$Progress.finish()
                this.loading = false
            })
        },
        onPageSizeChange(val) {
            this.setPagination({
                key: 'pageSize',
                val
            })

            this.updateBrandList(1)
        },
        onSetPage(page) {
            let validPage = page
            if (page < 1) {
                validPage = 1
            } else if (page > this.pagination.totalPages) {
                validPage = this.pagination.totalPages
            }

            this.setPagination({
                key: 'page',
                val: validPage
            })

            this.updateBrandList(page)
        },
        openRequestAccessModal(brandData) {
            this.requestAccessBrand = brandData
            this.isOpenRequestAccessBrandModal = true
        },
        closeRequestAccessModal() {
            this.requestAccessBrand = null
            this.isOpenRequestAccessBrandModal = false
        },
        sendBrandAccessRequest(brand) {
            if (this.isDemoUserMode()) return

            this.requestAccessToBrand(brand.BrandID).then(() => {
                this.$notify({
                    type: 'success',
                    text: `Запрос доступа к скрытым изделиям бренда “${brand.BrandName}” отправлены`
                })

                this.updateBrandList(this.pagination.page)
            })

            this.requestAccessBrand = null
            this.isOpenRequestAccessBrandModal = false
        },
        changeSubscription(brand, isSubscribed) {
            if (this.isDemoUserMode()) return

            if (isSubscribed) {
                this.subscribeOnBrand(brand.BrandID).then(() => {
                    this.$notify({
                        type: 'success',
                        text: `Вы подписались на бренд “${brand.BrandName}”`
                    })
                })
            } else {
                this.unsubscribeOnBrand(brand.BrandID).then(() => {
                    this.$notify({
                        type: 'success',
                        text: `Вы отписались от бренда “${brand.BrandName}”`
                    })
                })
            }
        },
        changeFavourite(brand, isFavourite) {
            if (isFavourite) {
                this.addBrandInFavourite(brand.BrandID).then(() => {
                    this.$notify({
                        type: 'success',
                        text: `Бренд “${brand.BrandName}” добавлен в избранное`
                    })
                })
            } else {
                this.removeBrandFromFavourite(brand.BrandID).then(() => {
                    this.$notify({
                        type: 'success',
                        text: `Бренд “${brand.BrandName}” удален из избранного`
                    })
                })
            }
        },
        search() {
            this.$Progress.start()
            this.updateBrandList(1)
        },
        applyFilter(filter) {
            this.$Progress.start()

            if (filter === this.filter) {
                this.filter = ''
            } else {
                this.filter = filter
            }

            this.setSelectedFilter({
                key: 'letter',
                val: filter
            })
            this.updateBrandList(1)
        },
        tryGetBrands() {
            if (this.selectedFilter) {
                this.filter = this.selectedFilter.letter
            }

            if (this.pagination.page) {
                this.updateBrandList(this.pagination.page)
            } else {
                this.updateBrandList(1)
            }
        }
    }
}
</script>
